/**
 * 리스트 페이지
 */

import Grid from "components/grid";
import ListHead from "components/subHead/listHead";
import { useSearchList, useUpdateStatus } from "./service";
import { detail, update, status } from "./handler";
import OptionDetail from "../detail";
import { useTranslation } from "react-i18next";
import OptionAddInfUpdate from "../update";
import { OptionAddInfProvider } from "../context";
import useModalStore from "store/modal";
import useMultiLangStore from "store/multiLang";
import useListRowInfStroe from "store/listRowInf";
import useAlertStore from "store/alert";

type IStatus = {
  uyn: string;
};
const ModalStatus = ({ uyn }: IStatus) => {
  const { t } = useTranslation();
  const nowStatus = uyn === "Y" ? t("uyn_y") : t("미사용");
  const nextStatus = uyn === "Y" ? t("미사용") : t("uyn_y");

  return (
    <div className="text-center font-bold">
      <h4>
        현재 객실옵션 상태는{" "}
        <span
          className={uyn === "Y" ? "text-green-500 px-1" : "text-red-600 px-1"}
        >
          [{nowStatus}]
        </span>
        입니다.
      </h4>
      <h4>
        객실옵션 상태를{" "}
        <span
          className={uyn === "Y" ? "text-red-600 px-1" : "text-green-600 px-1"}
        >
          [{nextStatus}]
        </span>
        변경하시겠습니까?
      </h4>
    </div>
  );
};

type IProps = {
  param: any;
};

export default function OptionList() {
  const { t } = useTranslation();

  const { rowData, pageNavRef } = useSearchList();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const onSetModal = useModalStore((state) => state.onSetModal);
  const resetMultiLang = useMultiLangStore((state) => state.resetMultiLang);
  const resetListRowParams = useListRowInfStroe(
    (state) => state.resetListRowParams
  );

  const { updateStatus } = useUpdateStatus();

  const theads = [
    ...prevTheads,
    {
      langNm: "grid_status",
      type: "uYn-btn",
      field: "uYn",
      width: 80,
      click: (props: any) => {
        status(props);

        onSetModal({
          isOpen: true,
          title: "상태변경",
          inner: <ModalStatus uyn={props.data.uyn} />,
          styles: "max-w-[380px]",
          chkBnt: true,
          cnclBtn: true,
          keep: true,
          onSetConfirm: () => {
            onSetAlert({
              isOpen: true,
              inner: "객실옵션상태를 변경하시겠습니까?",
              cnclBtn: true,
              onSetConfirm: () => {
                updateStatus();
              },
            });
          },
        });
      }, // 상태변경
    },
    {
      langNm: "grid_detail",
      type: "detail",
      field: "detail",
      width: 80,
      click: (props: any) => {
        resetListRowParams();
        detail(props);
        // 상세페이지 오픈
        onSetModal({
          title: t("md_ttl_rm_op_detail"),
          isOpen: true,
          styles: "w-full",
          inner: (
            <OptionAddInfProvider>
              <OptionDetail />
            </OptionAddInfProvider>
          ),
          onSetClose: () => {
            resetListRowParams();
          },
        });
      }, // 상세보기 모달 오픈
    },
    {
      langNm: "grid_modify",
      type: "modify",
      field: "update",
      width: 80,
      click: (props: any) => {
        resetListRowParams();
        update(props);
        resetMultiLang();
        //수정모달 오픈
        onSetModal({
          isOpen: true,
          title: t("sub_ttl_rm_op_edit"),
          styles: "w-full",
          inner: (
            <OptionAddInfProvider>
              <OptionAddInfUpdate />
            </OptionAddInfProvider>
          ),
          onSetClose: () => {
            resetListRowParams();
          },
        });
      }, // 수정모달 오픈
    },
  ];

  return (
    <>
      <ListHead totalRows={pageNavRef.current.totalRows} />
      <Grid theads={theads} rowData={rowData} pageNav={pageNavRef.current} />
    </>
  );
}

const prevTheads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_rm_no",
    type: "string",
    field: "rmNo",
  },
  {
    langNm: "grid_rm_nm",
    type: "string",
    field: "rmNm",
  },
  {
    langNm: "grid_op_rg_seq",
    type: "string",
    field: "opRgSeq",
  },
  {
    langNm: "grid_op_nm",
    type: "string",
    field: "rmOpNm",
    width: 120,
  },
  {
    langNm: "grid_brkf_yn",
    type: "string",
    field: "brkfInYn",
    width: 120,
  },
  {
    langNm: "grid_lat_chk_out_ti",
    type: "string",
    field: "latChkOutTi",
    width: 140,
  },
];
